// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__5dGFd","title":"Header_title__3DZPT","btns":"Header_btns__3x0Qa","btn":"Header_btn__2ed-4"};